var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { keyframes } from '../themes/styled';
import { themeGet } from '@styled-system/theme-get';
import Box from '../box/Box';
var dash = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["    \n    10% {\n        stroke-dashoffset: 250;\n    }\n\n    50% {\n        stroke-dashoffset: 0;\n    }\n\n    69.99% {\n        stroke-dashoffset: 0;\n    }\n\n    70% {\n        stroke-dashoffset: 500;\n    }\n\n    90% {\n        stroke-dashoffset: 250;\n    }\n"], ["    \n    10% {\n        stroke-dashoffset: 250;\n    }\n\n    50% {\n        stroke-dashoffset: 0;\n    }\n\n    69.99% {\n        stroke-dashoffset: 0;\n    }\n\n    70% {\n        stroke-dashoffset: 500;\n    }\n\n    90% {\n        stroke-dashoffset: 250;\n    }\n"])));
var Svg = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    -webkit-backface-visibility: hidden;\n\n    .squiggleMask {\n        stroke-dasharray: 250;\n        stroke-dashoffset: 250;\n        animation: ", " 2s cubic-bezier(0, 0, 0.15, 0.78) infinite;\n    }\n\n    .bg {\n        fill: ", ";\n    }\n\n    .squiggle {\n        fill: ", ";\n    }\n"], ["\n    -webkit-backface-visibility: hidden;\n\n    .squiggleMask {\n        stroke-dasharray: 250;\n        stroke-dashoffset: 250;\n        animation: ", " 2s cubic-bezier(0, 0, 0.15, 0.78) infinite;\n    }\n\n    .bg {\n        fill: ", ";\n    }\n\n    .squiggle {\n        fill: ", ";\n    }\n"])), dash, function (p) { return themeGet("colors.".concat(p.bg))(p); }, function (p) { return themeGet("colors.".concat(p.spinnerColor))(p); });
function getBg(bgShape) {
    switch (bgShape) {
        case 'circle':
            return React.createElement("circle", { className: "bg", cx: "115", cy: "115", r: "115" });
        case 'dash':
            return (React.createElement("path", { className: "bg", d: "M212.37,60.37,62.22,60.29a14.56,14.56,0,0,0-12.35,7.43L5.79,143.28C1.35,151-1.07,169.76,20.72,169.76l150,.08a14.64,14.64,0,0,0,12.51-7.43l45.69-78.87C233.2,76.11,234.17,60.37,212.37,60.37Z" }));
        default:
            return null;
    }
}
var LogoProgress = function (_a) {
    var showLoader = _a.showLoader, size = _a.size, bgShape = _a.bgShape, bg = _a.bg, spinnerColor = _a.spinnerColor, rest = __rest(_a, ["showLoader", "size", "bgShape", "bg", "spinnerColor"]);
    return showLoader ? (React.createElement(Box, __assign({}, rest),
        React.createElement(Svg, { viewBox: "0 0 231 231", width: size, height: size, bg: bg, spinnerColor: spinnerColor },
            React.createElement("defs", null,
                React.createElement("mask", { id: "mask" },
                    React.createElement("polyline", { className: "squiggleMask", points: "47.46 134.83 75.46 93.83 102.46 134.83 129.46 93.83 155.96 134.33 183.46 93.83", fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "20" }))),
            getBg(bgShape),
            React.createElement("path", { mask: "url(#mask)", d: "M110.59,137.94c-1,1.53-3.07,4.44-7,4.44H98.89c-1.78,0-3.88-2-5.33-4.52L75.72,107a.54.54,0,0,0-1,0L56.83,137.94a8.87,8.87,0,0,1-7.51,4.44H42.94c-2.5-.09-3.47-2.27-2.18-4.44L66.67,93.05a8.84,8.84,0,0,1,7.43-4.44h4.52c2.1,0,3.64,1.78,5.17,4.44l17.76,30.84c.16.32.56.65,1,0l17.84-30.84a9,9,0,0,1,7.43-4.44h4.52c2.1,0,3.63,1.78,5.17,4.44l17.75,30.84c.17.32.57.65,1,0l17.93-30.84a8.64,8.64,0,0,1,7.34-4.44h6.38a2.78,2.78,0,0,1,2.42,4.44l-26,44.89c-1,1.53-3.06,4.44-7,4.44h-4.68c-1.77,0-3.87-2-5.33-4.52L129.4,107a.54.54,0,0,0-1,0Z", className: "squiggle" })))) : null;
};
LogoProgress.defaultProps = {
    bg: 'black',
    bgShape: 'dash',
    size: 100,
    showLoader: false,
    spinnerColor: 'white',
};
export default LogoProgress;
var templateObject_1, templateObject_2;
//# sourceMappingURL=LogoProgress.js.map